module.exports = __webpack_public_path__ + "img/MM.b4dce306.png";